export default function formAPIdoctorassessment({
  plan,
  diagnosis,
  DATE,
  specality,
  doctorname,
  date,
  specialization,
  bookingid,
  updateddate,
  iscurrentvisit,
  id
})
{

  return Object.freeze({
    plan,
  diagnosis,
  DATE,
  specality,
  doctorname,
  date,
  specialization,
  bookingid,
  updateddate,
  iscurrentvisit,
  id
  });
}